import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';
import MobileTipsSlider from 'dpl/common/components/MobileTipsSlider';
import { EDUCATION_TIPS } from 'dpl/breeder_search_results/utils/constants';
import ClickableDiv from 'dpl/common/components/ClickableDiv';

export default function MobileEducationModule({ onLearnMoreClick }) {
  return (
    <div className="BreederSearchResultsEducationModule bg-yellow-10 pv6 br3 mb6 ph4">
      <p className="fw-medium f4 tc mb6">How Good Dog works</p>
      <div className="mb6">
        <MobileTipsSlider
          tips={EDUCATION_TIPS.map((tip, idx) => {
            const { title, img } = tip;
            return (
              <div key={idx}>
                <div className="justify-center flex mb4">
                  <ClickableDiv onClick={onLearnMoreClick}>
                    <SmartImage alt={title} src={img} />
                  </ClickableDiv>
                </div>

                <p className="tc fw-medium">{title}</p>
              </div>
            );
          })}
        />
      </div>
      <button
        type="button"
        className="w-100 h2 ba br3 tc fw-medium near-black bg-near-white b--light-gray"
        onClick={onLearnMoreClick}
      >
        Learn more
      </button>
    </div>
  );
}

MobileEducationModule.propTypes = {
  onLearnMoreClick: PropTypes.func.isRequired
};
